<template>
<!--答题答案-->
  <div id="examanswer">
    <h2 class="title">
      <a href="" class="prev"></a>
      <b>1</b>/20
      <div class="right">
        <a href=""><img src="../../assets/icon/examtest_icon_jj.png" alt="">交卷</a>
        <a href=""><img src="../../assets/icon/examtest_icon_dtk.png" alt="">答题卡</a>
        <a href=""><img src="../../assets/icon/examtest_icon_sc0.png" alt="">收藏</a>
      </div>
    </h2>
    <h3 class="type">单选题</h3>
    <div class="question">
      <div class="title">
        下列关于幼儿全面发展的说法错误的是（ ）
      </div>
      <div class="choice">
        <label>
          <dl>
            <dt><input type="radio" name="choice_answer"><i>A</i></dt>
            <dd>智力的发展，道德品质、意志的培养在很大程度上取决于健康状况</dd>
          </dl>
        </label>
        <label>
          <dl>
            <dt><input type="radio" name="choice_answer"><i>B</i></dt>
            <dd>美育有助于发展幼儿注意、观察、记忆、思维、想象等认知能力</dd>
          </dl>
        </label>
        <label>
          <dl>
            <dt><input type="radio" name="choice_answer"><i>C</i></dt>
            <dd>体育的作用最小</dd>
          </dl>
        </label>
        <label>
          <dl>
            <dt><input type="radio" name="choice_answer"><i>D</i></dt>
            <dd>美育能协调体、智、德育的发展，是体、智、德育的催化剂</dd>
          </dl>
        </label>
      </div>
    </div>
    <hr>
    <div class="analysis">
      <h4>答题解析</h4>
      <dl class="key">
        <dt>答案：</dt>
        <dd>C</dd>
      </dl>
      <dl class="detail">
        <dt>参考解析：</dt>
        <dd>
          <p>
            美育能协调体、智、德育的发展，是体、智、德育的催化剂美育能协调体、智、德育的发展，是体、智、德育的催化剂
          </p>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExamAnswer'
}
</script>

<style scoped lang="stylus">
  #examanswer
    h2.title
      position: relative
      height: 1.08rem
      line-height: .8rem
      background-color: transparent
      padding: .14rem .16rem
      font-size: .32rem
      color: #A3A9B7
      font-weight: 600
      text-align: center
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      b
        font-size: .48rem
        color: #FF7052
      a.prev
        position: absolute
        top: .14rem
        left: .16rem
        display: block
        width: .8rem
        height: .8rem
        background-color: transparent
        -webkit-border-radius: 50%
        -moz-border-radius: 50%
        border-radius: 50%
        &::before
          content: ""
          position: absolute
          top: .3rem
          left: .32rem
          display: block
          width: .20rem
          height: .20rem
          border-left: .03rem solid #050505
          border-bottom: .03rem solid #050505
          -webkit-transform: rotate(45deg)
          -moz-transform: rotate(45deg)
          -ms-transform: rotate(45deg)
          -o-transform: rotate(45deg)
          transform: rotate(45deg)
      .right
        position: absolute
        top: .3rem
        right: .4rem
        display: flex
        justify-content: space-between
        align-items: center
        width: 2.2rem
        height: .62rem
        a
          display: block
          width: .7rem
          line-height: .3rem
          height: 100%
          font-size: .22rem
          color: #333
          text-align: center
          img
            display: block
            width: .24rem
            height: .22rem
            margin: 0 auto .02rem
    h3.type
      padding: 0 .4rem
      margin: .3rem 0
      font-size: .48rem
      color: #050505
      font-weight: 600
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
    .question
      padding: 0 .4rem
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      .title
        font-size: .32rem
        color: #333
        text-align: left
        font-weight: 500
      .choice
        dl
          display: flex
          justify-content: space-between
          align-items: center
          margin-top: .4rem
          dt
            display: block
            width: .64rem
            height: .64rem
            i
              display: block
              width: .64rem
              height: .64rem
              line-height: .64rem
              border: .02rem solid #ccc
              font-size: .32rem
              color: #ccc
              text-align: center
              -webkit-box-sizing: border-box
              -moz-box-sizing: border-box
              box-sizing: border-box
              -webkit-border-radius: 50%
              -moz-border-radius: 50%
              border-radius: 50%
            input
              display: none
            input:checked + i
              border-color: #FF7052
              background-color: #FF7052
              color: #fff
          dd
            width: 5.8rem
            font-size: .28rem
            color: #999
    .question + hr
      width: 6.7rem
      height: .02rem
      background-color: #CFD1D4
      border: none
      margin: .6rem auto 0
    .analysis
      padding: 0 .4rem
      margin-top: .38rem
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      h4
        font-size: .28rem
        color: #FF7052
        text-align: left
      dl.key
        margin: .36rem 0 0
        dt
          display: inline-block
          font-size: .32rem
          color: #050505
          font-weight: 600
        dd
          display: inline-block
          font-size: .32rem
          color: #FF7052
      dl.detail
        margin: .2rem 0 0
        dt
          font-size: .32rem
          color: #050505
          font-weight: 600
        dd
          p
            margin: .2rem 0 0
            font-size: .28rem
            color: #666

</style>



// WEBPACK FOOTER //
// src/components/exam/ExamAnswer.vue